import React from "react";
import { SiteLayout } from "../components/site/SiteLayout";
import { useSeo } from "../lib/seo";

export default function TermsOfUsePage() {
  useSeo({
    title: "Terms of Use",
    description: "Terms governing use of the Wald Enterprise website.",
    path: "/terms-of-use",
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-20 md:py-28">
          <div className="eyebrow mb-6">Legal</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            Terms of Use
          </h1>
          <p className="mt-6 max-w-2xl opacity-70 text-sm">Last updated: 16 October 2026</p>
        </div>
      </section>
      <section>
        <div className="container-wald py-16 max-w-3xl space-y-10">
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Acceptance of terms</h2>
            <p className="opacity-85 leading-relaxed">
              By accessing wald.co.za (the "Site"), you agree to these Terms of Use. If you do not agree,
              please do not use the Site.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Use of the site</h2>
            <p className="opacity-85 leading-relaxed">
              The Site is provided for informational purposes about Wald Enterprise's services and
              products. You may not use the Site in any way that could damage, disable or impair it, or
              interfere with any other party's use of it.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Intellectual property</h2>
            <p className="opacity-85 leading-relaxed">
              All content on this Site — including text, graphics, logos and product names — is the
              property of Wald Enterprise or its licensors and is protected by applicable intellectual
              property laws. You may not reproduce or distribute it without our written permission.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Product &amp; availability information</h2>
            <p className="opacity-85 leading-relaxed">
              Where a product is described as "early access" or "live," that status reflects its current
              rollout stage and may change as development progresses. Product features and availability
              are described in good faith but may be updated without prior notice.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">No warranty</h2>
            <p className="opacity-85 leading-relaxed">
              The Site and its content are provided "as is" without warranties of any kind, express or
              implied. Wald Enterprise does not guarantee the Site will be uninterrupted or error-free.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Governing law</h2>
            <p className="opacity-85 leading-relaxed">
              These terms are governed by the laws of South Africa.
            </p>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight mb-3">Contact</h2>
            <p className="opacity-85 leading-relaxed">
              Questions about these terms can be directed to{" "}
              <a href="mailto:info@wald.co.za" className="copper-link underline underline-offset-2">info@wald.co.za</a>.
            </p>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
